@use '../../../../app/styles/common/mixins';

.offerDetails {
  &.expired {
    opacity: 0.5;
  }

  .offerInfo {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    .offerPriceSection {
      display: flex;
      flex-flow: column nowrap;

      // Figma (BP-8273): mobile/tablet — 4px above the price; desktop — 8px under the
      // price/discount block (the JSX moves it there on md+).
      .goodPriceLink {
        align-self: flex-start;
        margin-bottom: var(--spacing04);

        @include mixins.laptop {
          margin-top: var(--spacing08);
          margin-bottom: 0;
        }
      }

      .offerPrice {
        display: flex;
        align-items: center;

        @include mixins.line-clamp(1, ellipsis);
        @include mixins.heading-primary-500;

        @include mixins.laptop {
          height: 36px;
        }
      }

      .offerDiscount {
        display: flex;
        flex-flow: row nowrap;
        align-items: flex-start;
        gap: var(--spasing08);

        .oldPriceValue {
          text-decoration: line-through;
          color: var(--fg-secondary);

          @include mixins.line-clamp(1, ellipsis);
          @include mixins.heading-secondary-100;
        }

        .discountValue {
          color: var(--fg-primary);

          @include mixins.line-clamp(1, ellipsis);
          @include mixins.heading-secondary-100;
        }
      }
    }

    .offerTitle {
      color: var(--fg-primary);
      margin-top: var(--spasing08);

      @include mixins.line-clamp(2, ellipsis);
      @include mixins.heading-secondary-200;
    }

    &.noDiscount .offerTitle {
      margin-top: var(--spasing04);
    }

    // Desktop: the good-price link sits between price and title with 8px on both sides,
    // so the link keeps the 8px title gap that `.noDiscount` would otherwise shrink to 4px.
    &.noDiscount.withGoodPrice .offerTitle {
      @include mixins.laptop {
        margin-top: var(--spacing08);
      }
    }

    .badges {
      display: flex;
      flex-flow: row wrap;
      gap: var(--spasing04);

      margin-top: var(--spasing08);
      padding-top: var(--spasing08);
    }
  }

  .separator {
    margin: var(--spasing16) 0;
    height: 0;
    border: 1px dashed var(--border-secondary);
  }

  .seller {
    display: flex;
    flex-direction: column;
    gap: var(--spasing12);
  }
}

.sellerContacts {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: var(--spasing08);

  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: var(--spasing16);
  background-color: var(--surface-01);
  border-radius: var(--rounding16) var(--rounding16) 0 0;
  /* stylelint-disable-next-line color-function-alias-notation, function-disallowed-list */
  box-shadow: 0 -30px 60px 0 rgba(39 56 63 / 8%);
  z-index: 3;

  @include mixins.laptop {
    position: static;
    padding: 0;
    border-radius: 0;
    box-shadow: none;
    margin-top: var(--spasing24);
  }

  .registeredDate {
    color: var(--fg-secondary);
    text-align: center;

    @include mixins.caption-primary-450;
  }

  // Mobile-only seller preview shown above the action buttons in the bottom
  // sheet. Renders only when seller.activity is available (matches Figma
  // online/offline states; hidden in the no-info state).
  .profileMini {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: var(--spasing16);
    width: 100%;

    .profileMiniInfo {
      display: flex;
      flex: 1 1 auto;
      flex-direction: column;
      gap: 2px;
      overflow: hidden;
      min-width: 0;
    }

    .profileMiniNameRow {
      display: inline-flex;
      align-items: center;
      gap: var(--spasing04);
    }

    .profileMiniName {
      color: var(--fg-primary);

      @include mixins.caption-primary-500;
    }

    .profileMiniOnline {
      color: var(--fg-success);

      @include mixins.caption-primary-500;
    }

    .profileMiniResponseTime {
      color: var(--fg-secondary);

      @include mixins.caption-primary-450;
    }

    .profileMiniAvatar {
      flex: 0 0 auto;
      position: relative;

      .profileMiniImage {
        width: 40px;
        height: 40px;
      }

      &.profileMiniAvatarOnline::after {
        content: '';
        position: absolute;
        top: 0;
        right: 0;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: var(--bg-success);
        box-shadow: 0 0 0 2px var(--surface-01);
      }
    }
  }
}
